import React from 'react';
import { Loader2 } from 'lucide-react';

interface TaskConfirmationDialogProps {
  type: 'start' | 'end';
  onConfirm: () => void;
  onCancel: () => void;
  loading: boolean;
}

export function TaskConfirmationDialog({
  type,
  onConfirm,
  onCancel,
  loading,
}: TaskConfirmationDialogProps) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-light-card dark:bg-dark-card rounded-lg p-6 max-w-sm w-full">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4">
          {type === 'start' ? 'Start Task' : 'Complete Task'}
        </h3>
        <p className="text-gray-600 dark:text-gray-400 mb-6">
          {type === 'start'
            ? 'Are you sure you want to start this task? This will begin tracking your time.'
            : 'Are you sure you want to complete this task? This will stop the timer and submit your work.'}
        </p>
        <div className="flex justify-end gap-4">
          <button
            onClick={onCancel}
            className="px-4 py-2 text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="btn-primary"
          >
            {loading ? (
              <>
                <Loader2 className="h-4 w-4 animate-spin" />
                {type === 'start' ? 'Starting...' : 'Completing...'}
              </>
            ) : (
              type === 'start' ? 'Start Task' : 'Complete Task'
            )}
          </button>
        </div>
      </div>
    </div>
  );
}